// AuthorImageBlock.js
const AuthorImageBlock = ({ imageUrl }) => (
    <div>
      <img src={imageUrl} alt="Author" style={{ width: '100%' }} />
    </div>
  );
  
  export default AuthorImageBlock;
  